import React, { useCallback, useEffect, useState } from 'react';

import Status from 'components/field/Status';
import Form from 'components/form/Form';
import NoRecordsFound from 'components/global/NoRecordsFound';
import Typography from 'components/global/Typography';
import { ModalContent } from 'components/global/styled/Modal.styled';
import Table from 'components/table/Table';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useLocale from 'hooks/useLocale';

import { OTO_LINK } from 'services/consts';

import AppLogger from 'utils/AppLogger';

const OTOLinkStatusesModal = ({ sessionId }) => {
	const [statuses, setStatuses] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const { showError } = useAlert();
	const axiosPrivate = useAxiosPrivate();

	const getStatuses = useCallback(async () => {
		setIsLoading(true);
		try {
			const response = await axiosPrivate.post(OTO_LINK.GET_OTO_LINK_SESSION_LOGS, { sessionId });

			if (response.status === 200) {
				setStatuses(response?.data);
			}
		} catch (error) {
			AppLogger.error(error);
			showError();
		} finally {
			setIsLoading(false);
		}
	}, []);

	useEffect(() => {
		if (sessionId) {
			getStatuses();
		} else {
			showError();
		}
	}, []);

	return (
		<Form borderless>
			<ModalContent style={{ width: '100%' }}>
				<OTOLinkStatusesModalTable data={statuses} isLoading={isLoading} />
			</ModalContent>
		</Form>
	);
};

export default OTOLinkStatusesModal;

const OTOLinkStatusesModalTable = ({ data, isLoading }) => {
	const { getLocaleDateWithTime } = useLocale();
	const columns = React.useMemo(
		() => [
			{
				header: 'date',
				accessorKey: 'time',
				size: 60,
				renderCell: ({ row }) => <Typography>{getLocaleDateWithTime(row.original.time)}</Typography>
			},
			{
				header: 'description',
				accessorKey: 'description',
				size: 200,
				showOnMobile: true
			},
			{
				header: 'status',
				accessorKey: 'status',
				size: 100,
				renderCell: ({ row }) => <>{row.original.status ? <Status value={row.original.status} /> : ''}</>,
				showOnMobile: true
			}
		],
		[]
	);

	return (
		<Table
			columns={columns}
			data={data}
			loading={isLoading}
			noRecordsFound={
				<NoRecordsFound
					lottieName="no-history"
					height="10rem"
					title="noStatus"
					subTitle="noStatusesInThisOrder"
				/>
			}
		/>
	);
};
